import { Button } from "components/common/button/Button";
import { observer } from "mobx-react";
import React, { useCallback, useContext } from "react";
import { passwordContext } from "../../../state/passwordState";
import { profileContext } from "../../../state/profileState";
import { Input } from "../../common/input/Input";
import { validator } from "../../common/input/validator";
import { ModalProps } from "../Modals";
import "./ChangePassword.css";
import validate from "validate.js";
import { REGEXPS } from "../../../config";

export const ChangePasswordModal = observer(
  ({ showModal, closeModal }: ModalProps) => {
    const formName = "ChangePasswordModal";
    const passwordState = useContext(passwordContext);
    const profileState = useContext(profileContext);

    const submit = useCallback(() => {
      validator
        .validate(formName, true)
        .then(() => {
          passwordState
            .submitPassword(profileState.profileData!.login)
            .then(() => {
              profileState.unsetPasswordExpired();
              closeModal();
              profileState.logout();
            });
        })
        .catch(() => 0);
    }, [profileState, passwordState, formName, closeModal]);

    return (
      <>
        <div>
          <h2 className="subheader">Enter your new password</h2>
          {profileState.passwordExpired ? (
            <p className="expired">
              Your password has expired. Please set a new password below.
            </p>
          ) : null}
          <Input
            validateFunc={() =>
              validate.single(passwordState.newPassword, {
                presence: {
                  allowEmpty: false,
                  message: 'New password is required'
                },
                length: {
                  minimum: 14,
                  tooShort: "At least 14 characters are required",
                  maximum: 64,
                  tooLong: "No more than 64 characters are allowed"
                },
                format: {
                  pattern: REGEXPS.PASSWORD,
                  message: "Password must contain upper & lower case letters and numbers"
                }
              })
            }
            name="newPassword"
            formName={formName}
            type="password"
            label="New password"
            onChange={passwordState.changeNewPassword}
            value={passwordState.newPassword}
          />
          <Input
            name="newPasswordConfirm"
            validateFunc={() =>
              passwordState.confirmPassword === passwordState.newPassword
                ? undefined
                : ["Passwords don't match"]
            }
            formName={formName}
            type="password"
            label="Confirm password"
            onChange={passwordState.changeConfirmPassword}
            value={passwordState.confirmPassword}
          />
          <p>
          Password must be between 14 and 64 characters. Use a mixture of upper and lower case letters, at least one number and no spaces.
          </p>
        </div>

        <div className="modal-actions">
          <Button onClick={closeModal} className="btn btn-gray">
            Cancel
          </Button>
          <Button
            onClick={submit}
            className="btn btn-success"
            loading={passwordState.submitting}
          >
            Change password
          </Button>
        </div>
      </>
    );
  }
);
